<div class="row">
    <div class="mb-2 text-end">
        <a routerLink="../add" class="btn-add">
            <i class="fa fa-plus px-2"></i> Agregar
        </a>
    </div>
</div>
<div class="row">
    <div class="table-responsive">
        <table class="table">
            <thead class="thead-detail text-center">
                <tr class="table-success">
                    <th scope="col">N°</th>
                    <th scope="col">Tipo de pregunta</th>
                    <th scope="col">Grupo</th>
                    <th scope="col">Detalle</th>
                    <th scope="col">Activo</th>
                    <th scope="col"></th>
                    <th scope="col"></th>
                </tr>
            </thead>
            <tbody>
                <tr class="tbody-detail" *ngFor="let obj of qtypes; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>{{ obj.label }}</td>
                    <td>{{ obj.group }}</td>
                    <td>{{ obj.detail }}</td>
                    <td>
                        <div class="label-active text-center" *ngIf="obj.isActive">ACTIVO</div>
                        <div class="label-inactive text-center" *ngIf="!obj.isActive">INACTIVO</div>
                    </td>
                    <td><a class="a-icon text-center" [routerLink]="['/encuesta/org/tipo-preg/edit', obj.id]"><i
                                class="fa fa-pencil i-icon"></i></a></td>
                    <td><a class="a-icon text-center"><i class="fa fa-trash i-icon"></i></a></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>